export const PRIMARY_COLOR = "#45129E";
export const SECONDARY_COLOR = "#F91EAF";
export const LIGHT_SECONDARY_COLOR = "#fda5df"
export const WARNING_COLOR = "#FFC107";
export const DANGER_COLOR = "#ed1c23";
export const SUCCESS_COLOR = "#4caf50";
export const INFO_COLOR = "#2196f3";
export const BLACK_COLOR = "#000";
export const WHITE_COLOR = "#FFF";
export const GREY_COLOR = "#dedede";
export const ORANGE_COLOR = "#FF8300";
export const LIGHT_GREY_COLOR = "#F8F8F8";
export const REGULAR_COLOR = "#4312a1";
export const BRONZE_COLOR = "#cc812e";
export const SILVER_COLOR = "#a6a6a6";
export const GOLD_COLOR = "#d0b132";
export const LIGHT_PURPLE = "#9e77ba";

